import React from 'react';
import { useTranslation } from 'react-i18next';
import ProChip from './ProChip';
import { useProShellNavigate } from '../../utils/proShellNavigation';

interface QuickActionTile {
  key: string;
  nameKey: string;
  href: string;
}

const TILES: QuickActionTile[] = [
  { key: 'bills', nameKey: 'nav.bills', href: '/pro/bills' },
  { key: 'legislators', nameKey: 'nav.legislators', href: '/pro/legislators' },
  { key: 'calendar', nameKey: 'nav.calendar', href: '/pro/calendar' },
  { key: 'workspaces', nameKey: 'nav.workspaces', href: '/pro/workspaces' },
];

/**
 * Pro mobile dashboard quick-actions strip.
 *
 * Horizontal scroll of text-only `IonChip`s that jump to the main Pro
 * sections. Keeps the dashboard tight — users no longer need to open the
 * drawer to reach Bills, Legislators, Calendar, or Workspaces from home.
 */
const ProQuickActions: React.FC = () => {
  const { t } = useTranslation('pro');
  const shellNavigate = useProShellNavigate();

  return (
    <div
      className="pro-filter-chips flex items-center gap-2 px-3 pt-6 pb-0"
      style={{ overflowX: 'auto', flexWrap: 'nowrap', WebkitOverflowScrolling: 'touch' }}
    >
      {TILES.map((tile) => (
        <ProChip
          key={tile.key}
          size="comfortable"
          onClick={() => shellNavigate(tile.href)}
          className="bg-white text-text-primary dark:bg-primary-800 dark:text-text-dark-primary border border-border-light dark:border-white/10"
        >
          {t(tile.nameKey)}
        </ProChip>
      ))}
    </div>
  );
};

export default ProQuickActions;
